// ============================================================
// Edit Student Page
// ============================================================

import { Box, CircularProgress, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { PageHeader } from '@/components/navigation/PageHeader';
import { usePageMeta } from '@/hooks/usePageMeta';
import { AddStudentWizard } from './components/forms/AddStudentWizard';
import { useStudent } from '@/hooks/useStudent';

export function EditStudentPage() {
  const { id } = useParams();
  const { student, loading, error } = useStudent(id);

  usePageMeta('Edit Student', [
    { label: 'Students', path: '/students' },
    { label: 'List', path: '/students/list' },
    { label: 'Edit' },
  ]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !student) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography color="error" variant="h6">
          {error || 'Student not found'}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ pb: 6 }}>
      <PageHeader 
        title="Edit Student" 
        subtitle="Update the existing student's details using the multi-step wizard." 
      />
      <AddStudentWizard initialData={student} isEditMode={true} />
    </Box>
  );
}
